module.exports = "pegasus_template/assets/email1-img12.png";